import { adminPagesLabsEntryPoint } from '@jira/spa-apps__admin-pages-labs/src/adminPagesLabsEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { globalSettingsSystemLabsRoute } from '@jira/router-routes__admin-pages-system-routes/src/globalSettingsSystemLabsRoute.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router/src/common/types';
import { fg } from '@atlassian/jira-feature-gating';

const pageEntryPoint = createPageEntryPoint({
	main: adminPagesLabsEntryPoint,
});

export const globalSettingsSystemLabsRouteEntry: Route = createEntry(
	globalSettingsSystemLabsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.system.labs',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		entryPoint: () => {
			if (!fg('jira_labs_refresh_m1')) {
				return undefined;
			}

			return pageEntryPoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
